/*global
L
*/

// const countries_topo_data = require("./countries_topo.json");
// based on https://raw.githubusercontent.com/danutzthe/topojson_world_map/master/world-110m.json
// countries_topo_2.json is like 600KB instead of 100kb, but it looks a lot better and once minimized does not seem
// to add more than 200kb to payload. Compressed it's probably even less.
// Sucks that it gets added to our bundle ... but then that's only really loaded once. Meh.
const countries_topo_data = require("./countries_topo_2.json");

const topojson = require("topojson");
import chroma from "chroma-js";
import $ from "jquery";

const colorScale = (v) => {
  if (v === "notSurveyed") { return chroma("gray"); }
  if (v === "notSurveyedThisYear") { return chroma("green"); }
  if (v === "new") { return chroma("orange"); }

  return chroma.scale(["red", "white", "blue"]).domain([-1, 0, 10])(+v).hex();
};

const initTopoJsonLayer = function (map, countryOptions, layerEventHandlers, selectedCountry) {
  if (!L.TopoJSON) {
    L.TopoJSON = L.GeoJSON.extend({
      addData: function(jsonData) {
        if (jsonData.type === "Topology") {
          for (const key in jsonData.objects) {
            const geojson = topojson.feature(jsonData, jsonData.objects[key]);
            L.GeoJSON.prototype.addData.call(this, geojson);
          }
        }
        else {
          L.GeoJSON.prototype.addData.call(this, jsonData);
        }
      }
    });
  }

  const topoLayer = new L.TopoJSON();

  const addTopoData = function (topoData) {
    topoLayer.addData(topoData);
    topoLayer.addTo(map);
  };

  addTopoData(countries_topo_data);

  // enterLayer and leaveLayer need to be able to call each other;
  let leaveLayer;
  const enterLayer = function () {
    if (topoLayer.defaultLayer && topoLayer.defaultLayer !== this) {
      leaveLayer.bind(topoLayer.defaultLayer)(topoLayer.defaultLayer, true);
    }

    const text = this.feature.properties.tooltip;

    this.bringToFront();
    this.setStyle({
      weight:2,
      opacity: 1
    });

    layerEventHandlers.enterLayer(text);
  };

  leaveLayer = function (layerBeingLeft, forceLeave) {
    if (topoLayer.defaultLayer === this && !forceLeave) {
      return;
    }

    this.bringToBack();
    this.setStyle({
      weight: 1,
      opacity: .5
    });

    layerEventHandlers.leaveLayer();

    if (topoLayer.defaultLayer && topoLayer.defaultLayer !== this) {
      enterLayer.bind(topoLayer.defaultLayer)();
    }
  };

  const selectLayer = function () {
    if (!this.feature.properties.surveyed) { return; }
    layerEventHandlers.selectLayer(this.feature.properties.name);
  };

  topoLayer.defaultLayer = null;

  const handleLayer = function (layer) {
    const countryName = layer.feature.properties.name;
    const optionsForLayer = countryOptions[countryName];

    let value, tooltip, surveyed;
    if (optionsForLayer) {
      value = optionsForLayer.value;
      tooltip = optionsForLayer.tooltip;
      surveyed = true;
    } else {
      value = "notSurveyed";
      tooltip = `${countryName} - Not surveyed. Cannot be selected.`;
      surveyed = false;
    }
    const fillColor = colorScale(value);

    layer.setStyle({
      fillColor : fillColor,
      fillOpacity: 0.6,
      color: "#555",
      weight: 1,
      opacity: 0.5
    });

    layer.feature.properties.tooltip = tooltip;
    layer.feature.properties.surveyed = surveyed;

    layer.on({
      mouseover: enterLayer,
      mouseout: leaveLayer,
      click: selectLayer
    });

    if (selectedCountry && selectedCountry.value === countryName) {
      topoLayer.defaultLayer = layer;
    }
  };

  topoLayer.eachLayer(handleLayer);
  topoLayer.enterLayer = enterLayer;

  return topoLayer;
};

const tariffSurveyMapBuilder = function (leafletHtmlID, mapOptions) {
  if ($("main").hasClass("print")) { return; }
  const container = $("#" + leafletHtmlID).closest(".visualization-wrapper");

  const markerOptions = mapOptions.markers;

  const map = L.map(leafletHtmlID, {
    attributionControl: false,
    zoomControl: true,
    zoomControlPosition: "top-left",
    center: [30, 20],
    zoom: 1.75,
    maxZoom: 9,
    minZoom: 1,
    scrollWheelZoom: false
  });
  const layerEventHandlers = {
    leaveLayer: () => {},
    enterLayer: () => {},
    selectLayer: mapOptions.selectCountryInMap
  };
  const countryLayerOptions = mapOptions.country_price_changes;
  const selectedCountry = mapOptions.selectedCountry;
  const topoLayer = initTopoJsonLayer(map, countryLayerOptions, layerEventHandlers, selectedCountry);

  // Null island is not a place.
  const maybeThrowBecauseOfNullCoords = function (coords) {
    const nullIsland = coords && coords[0] == 0 && coords[1] == 0 && coords.length == 2;

    if (nullIsland) {
      throw "NullCoordinatesInList";
    }
  };

  // START OF MAP MARKER CODE
  const markerClusterGroup = L.markerClusterGroup.layerSupport({
    iconCreateFunction: function(cluster) {
      const childCount = cluster.getChildCount();
      const children = cluster.getAllChildMarkers();
      const layerTypes = $.map(children, function (e) {
        return e.options.layer_type_class;
      });

      const uniqueSorted = $.uniqueSort(layerTypes);
      const allOnePlantType = uniqueSorted.length === 1;
      const firstPlantType = uniqueSorted[0];

      const layerTypeClass = allOnePlantType ? firstPlantType : "multiple-types";

      const c = " marker-cluster-large";

      return new L.DivIcon({ html: "<div><span>" + childCount + "</span></div>", className: "marker-cluster marker-cluster-" + layerTypeClass + c, iconSize: new L.Point(40, 40) });
    }
  });

  const titles = {
    "organisation": "City"
  };

  const layerTypeGroups = {};

  for (const key in titles) {
    if (titles.hasOwnProperty(key)) {
      layerTypeGroups[key] = [];
    }
  }

  const allMarkers = [];
  if (markerOptions.length > 0) {
    $.each(markerOptions, function (i, markerOptionObject) {
      const coordPair = markerOptionObject.coordinates;
      const popUp = markerOptionObject.pop_up;
      const tooltip = markerOptionObject.tooltip;

      maybeThrowBecauseOfNullCoords(coordPair);

      const icon = L.icon({
        iconUrl: markerOptionObject.icon_png,
        shadowUrl: markerOptionObject.shadow_png,
        iconSize: [32, 50],
        iconAnchor: [16, 50],
        popupAnchor: [0, -50]
      });
      const marker = L.marker(coordPair, {
        tooltip: {
          html: tooltip
        },
        icon: icon,
        layer_type_class: markerOptionObject.layer_type_class
      });

      const popUpOptions = {
        className: markerOptionObject.layer_type_class
      };
      marker.bindPopup(popUp, popUpOptions);

      allMarkers.push(marker);
      layerTypeGroups[markerOptionObject.layer_type_class].push(marker);
    });

    const layerTypeLayers = {};
    let count;
    let title;
    let layerTypeGroup;

    for (const prop in layerTypeGroups) {
      if (layerTypeGroups.hasOwnProperty(prop)) {
        layerTypeGroup = layerTypeGroups[prop];
        count = layerTypeGroup.length;

        if (count > 0) {
          title = titles[prop] + " (" + count + ")";
          layerTypeLayers[title] = L.layerGroup(layerTypeGroups[prop]);
        }
      }
    }
    map.addLayer(markerClusterGroup);

    let layer, i = 0;
    for (const prop2 in layerTypeLayers) {
      if (layerTypeLayers.hasOwnProperty(prop2)) {
        layer = layerTypeLayers[prop2];

        markerClusterGroup.checkIn(layer);

        map.addLayer(layerTypeLayers[prop2]);
      }
    }

    for (const prop3 in layerTypeLayers) {
      if (layerTypeLayers.hasOwnProperty(prop3)) {
        layer = layerTypeLayers[prop3];

        if (i++ > 0) {
          map.removeLayer(layerTypeLayers[prop3]);
        }
      }
    }

    container.on("leafresize", function (e) {
      map.invalidateSize();

      e.stopPropagation();
    });
  }
  // END OF MAP MARKER CODE

  // Add the country tooltip, only when a country is SELECTED OR HOVERED
  const info = L.control();
  info.onAdd = function () {
    this._div = L.DomUtil.create("div", "info");
    this.update();
    return this._div;
  };

  info.update = function (tooltipText) {
    let body;

    if (!tooltipText) {
      body = "Hover or click on a country";
    } else {
      body = tooltipText;
    }

    this._div.innerHTML = body;
  };
  info.addTo(map);
  layerEventHandlers.enterLayer = (text) => {
    info.update(text);
  };
  layerEventHandlers.leaveLayer = () => {
    info.update();
  };

  // add the color legend guide
  const legend = L.control({ position: "bottomright" });
  legend.onAdd = function () {
    const div = L.DomUtil.create("div", "info legend");
    let html = "";
    const gradesAndLabels = {
      notSurveyed: "Country not surveyed",
      notSurveyedThisYear: "Country not surveyed this year",
      new: "Country newly surveyed"
    };

    Object.entries(gradesAndLabels).map(([grade, label]) => {
      html += `<p><i style="background: ${colorScale(grade)}"></i> ${label}</p>`;
    });

    html += "<p class='color-widget-title'>% increase in combined tariff</p><p>";

    const changeSamples = {
      "-1": "-1",
      "-0.5": false,
      "0": "0",
      "2.5": false,
      "5": "5",
      "7.5": false,
      "10": "10"
    };

    Object.entries(changeSamples).sort(([gradeA], [gradeB]) => (+gradeA) - (+gradeB)).map(([grade, label]) => {
      const l = label ? ` <span class="label">${label}</span>` : "";
      html += `<span class="legend-color"><i style="background: ${colorScale(grade)}"></i>${l}</span>`;
    });

    html += "</p>";

    div.innerHTML += html;

    return div;
  };
  legend.addTo(map);

  // Final initialization
  window.tariffMap = map;

  map.removeProperly = function () {
    map.eachLayer(function (layer) {
      map.removeLayer(layer);
    });
    markerClusterGroup._layers = {};

    map.remove();
  };

  let bounds;
  if (topoLayer.defaultLayer) {
    topoLayer.enterLayer.bind(topoLayer.defaultLayer)();
    bounds = topoLayer.defaultLayer.getBounds();
  } else {
    if (allMarkers.length > 0) {
      bounds = markerClusterGroup.getBounds();
    }
  }

  if (bounds) {
    window.setTimeout(function () {
      map.fitBounds(bounds, { padding: [0, 0] });
      if (map.getZoom() > 4) { map.setZoom(4); }
    }, 0);
  }
};

export default tariffSurveyMapBuilder;
